// TODO: find a better solution for svg fillings
export const $cabin = () => {
  return '#00acc1'
}

export const $selectedCabin = () => {
  return '#018000'
} 